import { apiEndpoints } from '@/lib/api/endpoints'
import { mapPharmacyMedicationsResponse } from '@/lib/store/api/directoryPharmacy/mapDirectoryPharmacyResponse'
import type {
    DirectoryPharmacyMedicationsResponse,
    PharmacyDetailPageMedicationsApiResponse,
} from '@/lib/store/api/directoryPharmacy/types'
import { baseApi } from './baseQuery'

export const directoryPharmacyApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getPharmacyMedications: builder.query<
            DirectoryPharmacyMedicationsResponse,
            { friendlyId: string; page: number; perPage?: number }
        >({
            query: ({ friendlyId, page, perPage = 50 }) =>
                apiEndpoints.pharmacyDetailPages.medications(friendlyId, page, perPage),
            transformResponse: (response: PharmacyDetailPageMedicationsApiResponse) =>
                mapPharmacyMedicationsResponse(response),
            providesTags: (_result, _error, { friendlyId }) => [
                { type: 'PharmacyMedications', id: friendlyId },
            ],
        }),
    }),
    overrideExisting: false,
})

export const { useLazyGetPharmacyMedicationsQuery } = directoryPharmacyApi
